import { cx } from './cx.js';

/**
 * The visible half of instant save. Controls that write on change used to give
 * no signal at all: a successful change looked identical to a rejected one,
 * and a rejected one silently reverted on the next refetch.
 */
export type SaveState =
  | { status: 'idle' }
  | { status: 'saving' }
  | { status: 'saved' }
  | { status: 'error'; message: string };

export function SavedIndicator({
  state,
  className,
}: {
  state: SaveState;
  className?: string | undefined;
}) {
  if (state.status === 'idle') return null;
  const tone = state.status === 'error' ? 'error' : 'ok';
  return (
    <span className={cx('ui-saved', `ui-saved--${tone}`, className)} role="status">
      {state.status === 'saving' ? 'Saving…' : null}
      {state.status === 'saved' ? '✓ Saved' : null}
      {state.status === 'error' ? `⚠ Not saved: ${state.message}` : null}
    </span>
  );
}
